import React from 'react';
import { Screen } from '../App';
import { getAccountRole } from '../api';
interface Props { navigate: (s: Screen) => void; active: Screen; }
export default function NavBar({ navigate, active }: Props) {
  // Parent Mode: the role is set once at login (App → setAccountRole) and is
  // stable for the session, so reading it here keeps the tab label in sync
  // without threading `user` through every screen that renders the nav.
  const studentsLabel = getAccountRole() === 'parent' ? 'My Kids' : 'Students';
  const items = [
    { s: 'dashboard' as Screen, label: 'Home', icon: <><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></> },
    { s: 'students' as Screen, label: studentsLabel, icon: <><circle cx="9" cy="7" r="4"/><path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/><path d="M21 21v-2a4 4 0 0 0-3-3.85"/></> },
    { s: 'wins' as Screen, label: 'Wins', icon: <><polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/></> },
    { s: 'library' as Screen, label: 'Library', icon: <><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></> },
  ];
  return (
    <nav className="bottom-nav">
      {items.map(({s,label,icon})=>(
        <button key={s} className={`bottom-nav-item ${active===s?'active':''}`} onClick={()=>navigate(s)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">{icon}</svg>
          {label}
        </button>
      ))}
    </nav>
  );
}
